export default __webpack_public_path__ + "static/media/05.2bc7488c.webp";